//==== Country Flags ===//
import { Paksitan } from "./flags/Paksitan";
import { France } from "./flags/France";
import { Japan } from "./flags/Japan";
import { Australia } from "./flags/Australia";
import { Germany } from "./flags/Germany";
import { Canada } from "./flags/Canada";
import { Uk } from "./flags/UK";
import { SouthAfrica } from "./flags/SouthAfrica";
import { UnitedStates } from "./flags/UnitedStates";
import { Bangladesh } from "./flags/Bangladesh";
import { Austria } from "./flags/Austria";
import { Belgium } from "./flags/Belgium";
import { Brazil } from "./flags/Brazil";
import { Bulgaria } from "./flags/Bulgaria";
import { CoteDIvoire } from "./flags/CoteDIvoire";
import { Croatia } from "./flags/Croatia";
import { Cyprus } from "./flags/Cyprus";
import { CzechRepublic } from "./flags/CzechRepublic";
import { Denmark } from "./flags/Denmark";
import { Estonia } from "./flags/Estonia";
import { Finland } from "./flags/Finland";
import { Ghana } from "./flags/Ghana";
import { Gibraltar } from "./flags/Gibraltar";
import { Greece } from "./flags/Greece";
import { HongKong } from "./flags/HongKong";
import { Hungary } from "./flags/Hungary";
import { India } from "./flags/India";
import { Indonesia } from "./flags/Indonesia";
import { Ireland } from "./flags/Ireland";
import { Italy } from "./flags/Italy";
import { Kenya } from "./flags/Kenya";
import { Latvia } from "./flags/Latvia";
import { Liechtenstein } from "./flags/Liechtenstein";
import { Lithuania } from "./flags/Lithuania";
import { Luxembourg } from "./flags/Luxembourg";
import { Malaysia } from "./flags/Malaysia";
import { Malta } from "./flags/Malta";
import { Mexico } from "./flags/Mexico";
import { Netherlands } from "./flags/Netherlands";
import { NewZealand } from "./flags/NewZealand";
import { Nigeria } from "./flags/Nigeria";
import { Norway } from "./flags/Norway";
import { Poland } from "./flags/Poland";
import { Portugal } from "./flags/Portugal";
import { Romania } from "./flags/Romania";
import { Singapore } from "./flags/Singapore";
import { Slovakia } from "./flags/Slovakia";
import { Slovenia } from "./flags/Slovenia";
import { Spain } from "./flags/Spain";
import { Sweden } from "./flags/Sweden";
import { Switzerland } from "./flags/Switzerland";
import { Thailand } from "./flags/Thailand";
import { UnitedArabEmirates } from "./flags/UnitedArabEmirates";

const countryList = [
  {
    label: "United States",
    phone: "+1",
    flag: <UnitedStates />,
    format: "(###) ###-####",
  },
  {
    label: "Bangladesh",
    phone: "+880",
    flag: <Bangladesh />,
    format: "### ### ### ###",
  },
  {
    label: "Pakistan",
    phone: "+92",
    flag: <Paksitan />,
    format: "###-#######",
  },

  {
    label: "France",
    phone: "+33",
    flag: <France />,
    format: "# ## ## ## ##",
  },

  {
    label: "Japan",
    phone: "+81",
    flag: <Japan />,
    format: "###-###-####",
  },

  {
    label: "Australia",
    phone: "+61",
    flag: <Australia />,
    format: "# #### ####",
  },

  {
    label: "Germany",
    phone: "+49",
    flag: <Germany />,
    format: "### #######",
  },

  {
    label: "Canada",
    phone: "+1",
    flag: <Canada />,
    format: "(###) ###-####",
  },

  {
    label: "UK",
    phone: "+44",
    flag: <Uk />,
    format: "#### ######",
  },
  {
    label: "United Kingdom",
    phone: "+44",
    flag: <Uk />,
    format: "#### ######",
  },

  {
    label: "South Africa",
    phone: "+27",
    flag: <SouthAfrica />,
    format: "#### ######",
  },
  {
    label: "Austria",
    phone: "+43",
    flag: <Austria />,
    format: "### #######",
  },
  {
    label: "Belgium",
    phone: "+32",
    flag: <Belgium />,
    format: "### ## ## ##",
  },
  {
    label: "Brazil",
    phone: "+55",
    flag: <Brazil />,
    format: "## #####-####",
  },
  {
    label: "Bulgaria",
    phone: "+359",
    flag: <Bulgaria />,
    format: "## ### ####",
  },
  {
    label: "Côte d'Ivoire",
    phone: "+225",
    flag: <CoteDIvoire />,
    format: "## ## ## ##",
  },
  {
    label: "Croatia",
    phone: "+385",
    flag: <Croatia />,
    format: "## #######",
  },
  {
    label: "Cyprus",
    phone: "+357",
    flag: <Cyprus />,
    format: "## ######",
  },
  {
    label: "Czech Republic",
    phone: "+420",
    flag: <CzechRepublic />,
    format: "### ### ###",
  },
  {
    label: "Denmark",
    phone: "+45",
    flag: <Denmark />,
    format: "## ## ## ##",
  },
  {
    label: "Estonia",
    phone: "+372",
    flag: <Estonia />,
    format: "#### ####",
  },
  {
    label: "Finland",
    phone: "+358",
    flag: <Finland />,
    format: "## ### ####",
  },
  {
    label: "Ghana",
    phone: "+233",
    flag: <Ghana />,
    format: "## ### ####",
  },
  {
    label: "Gibraltar",
    phone: "+350",
    flag: <Gibraltar />,
    format: "#### ####",
  },
  {
    label: "Greece",
    phone: "+30",
    flag: <Greece />,
    format: "## #### ####",
  },
  {
    label: "Hong Kong",
    phone: "+852",
    flag: <HongKong />,
    format: "#### ####",
  },
  {
    label: "Hungary",
    phone: "+36",
    flag: <Hungary />,
    format: "## ### ####",
  },
  {
    label: "India",
    phone: "+91",
    flag: <India />,
    format: "##### #####",
  },
  {
    label: "Indonesia",
    phone: "+62",
    flag: <Indonesia />,
    format: "### ### ####",
  },
  {
    label: "Ireland",
    phone: "+353",
    flag: <Ireland />,
    format: "## ### ####",
  },
  {
    label: "Italy",
    phone: "+39",
    flag: <Italy />,
    format: "### ### ####",
  },
  {
    label: "Kenya",
    phone: "+254",
    flag: <Kenya />,
    format: "### ######",
  },
  {
    label: "Latvia",
    phone: "+371",
    flag: <Latvia />,
    format: "## ### ###",
  },
  {
    label: "Liechtenstein",
    phone: "+423",
    flag: <Liechtenstein />,
    format: "### ### ###",
  },
  {
    label: "Lithuania",
    phone: "+370",
    flag: <Lithuania />,
    format: "### #####",
  },
  {
    label: "Luxembourg",
    phone: "+352",
    flag: <Luxembourg />,
    format: "### ### ###",
  },
  {
    label: "Malaysia",
    phone: "+60",
    flag: <Malaysia />,
    format: "##-#### ####",
  },
  {
    label: "Malta",
    phone: "+356",
    flag: <Malta />,
    format: "#### ####",
  },
  {
    label: "Mexico",
    phone: "+52",
    flag: <Mexico />,
    format: "## #### ####",
  },
  {
    label: "Netherlands",
    phone: "+31",
    flag: <Netherlands />,
    format: "## ### ####",
  },
  {
    label: "New Zealand",
    phone: "+64",
    flag: <NewZealand />,
    format: "## ### ####",
  },
  {
    label: "Nigeria",
    phone: "+234",
    flag: <Nigeria />,
    format: "### ### ####",
  },
  {
    label: "Norway",
    phone: "+47",
    flag: <Norway />,
    format: "### ## ###",
  },
  {
    label: "Poland",
    phone: "+48",
    flag: <Poland />,
    format: "## ### ## ##",
  },
  {
    label: "Portugal",
    phone: "+351",
    flag: <Portugal />,
    format: "### ### ###",
  },
  {
    label: "Romania",
    phone: "+40",
    flag: <Romania />,
    format: "### ### ###",
  },
  {
    label: "Singapore",
    phone: "+65",
    flag: <Singapore />,
    format: "#### ####",
  },
  {
    label: "Slovakia",
    phone: "+421",
    flag: <Slovakia />,
    format: "### ### ###",
  },
  {
    label: "Slovenia",
    phone: "+386",
    flag: <Slovenia />,
    format: "## ### ###",
  },
  {
    label: "Spain",
    phone: "+34",
    flag: <Spain />,
    format: "### ### ###",
  },
  {
    label: "Sweden",
    phone: "+46",
    flag: <Sweden />,
    format: "##-### ## ##",
  },
  {
    label: "Switzerland",
    phone: "+41",
    flag: <Switzerland />,
    format: "## ### ## ##",
  },
  {
    label: "Thailand",
    phone: "+66",
    flag: <Thailand />,
    format: "## ### ####",
  },
  {
    label: "United Arab Emirates",
    phone: "+971",
    flag: <UnitedArabEmirates />,
    format: "## ### ####",
  },
];

export const countries = countryList.sort((a, b) =>
  a.label.localeCompare(b.label)
);
